var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewPdfEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 29.2,
    height: 29.2,
    rx: 14.6,
    stroke: "#15345A",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.428C13.1079 18.428 11.5721 16.8921 11.5721 15.0001C11.5721 13.108 13.1079 11.5721 15 11.5721C16.8921 11.5721 18.4279 13.108 18.4279 15.0001C18.4279 16.8921 16.8921 18.428 15 18.428ZM15 12.7596C13.765 12.7596 12.7596 13.7651 12.7596 15.0001C12.7596 16.2351 13.765 17.2405 15 17.2405C16.235 17.2405 17.2404 16.2351 17.2404 15.0001C17.2404 13.7651 16.235 12.7596 15 12.7596Z",
    fill: "#15345A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.1408C12.0233 22.1408 9.2129 20.3991 7.28123 17.375C6.44206 16.0687 6.44206 13.9391 7.28123 12.625C9.22081 9.6008 12.0312 7.85913 15 7.85913C17.9687 7.85913 20.7791 9.6008 22.7108 12.625C23.55 13.9312 23.55 16.0608 22.7108 17.375C20.7791 20.3991 17.9687 22.1408 15 22.1408ZM15 9.04663C12.4429 9.04663 9.99665 10.5825 8.28665 13.2662C7.6929 14.1925 7.6929 15.8075 8.28665 16.7337C9.99665 19.4175 12.4429 20.9533 15 20.9533C17.5571 20.9533 20.0033 19.4175 21.7133 16.7337C22.3071 15.8075 22.3071 14.1925 21.7133 13.2662C20.0033 10.5825 17.5571 9.04663 15 9.04663Z",
    fill: "#15345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPdfEyeIcon);
export default __webpack_public_path__ + "static/media/viewPdfEyeIcon.63ecf3f552cf08ad6b23895244464911.svg";
export { ForwardRef as ReactComponent };